import Inko from 'inko';
import { clientInstance, authInstance, } from '@/api/core';
import { errorCodes } from '@/constants';
import vuexStore from '@/vuex-store';
import { apiAbortManager } from '@/lib/api-abort-manager';
import { i18n } from '@/locales';
import { routeName } from '@/constants/routeName';
import { BusinessError, errorCode, } from '@/error';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import slackWebHook from '@/lib/slack-web-hook';
import { userGetterType } from '@/vuex-store/user/getters';
import { authGetterType } from '@/vuex-store/auth/getters';
const inko = new Inko();
const onApiRequest = (config) => {
    // 인증 정보 핸들링 획일화
    const isAuthenticated = vuexStore.getters[authGetterType.isAuthenticated];
    const userId = vuexStore.getters[userGetterType.userId];
    const customHeader = {};
    // auth api에서는 header에 Authorization 추가 안되도록 해야 함
    if (!config.url.includes('oauth2/token')
        && isAuthenticated) {
        customHeader.Authorization = vuexStore.getters[authGetterType.bearerToken];
    }
    if (userId) {
        customHeader['hcr-user-id'] = inko.ko2en(userId);
    }
    Object.assign(config, {
        headers: customHeader,
    });
    // api 취소 핸들링을 위한 abort signal 주입
    const signal = apiAbortManager.getSignal();
    Object.assign(config, {
        signal,
    });
    return config;
};
const onApiRequestError = (error) => Promise.reject(error);
/**
 * api 성공 응답 핸들러
 */
const onApiResponse = (response) => {
    const { data } = response;
    const { isSuccess = undefined, } = data.data ?? {};
    // api는 성공 했지만 상태가 실패 상태인 것들 throw BusinessError
    if (isSuccess !== undefined
        && isSuccess === false) {
        const { message, reason, } = data.data;
        throw new BusinessError({
            code: errorCode.BAD_REQUEST,
            message,
            reason,
        });
    }
    return response;
};
/**
 * api 실패 응답 핸들러
 */
const onApiResponseError = async (_error) => {
    const { code, status, config, } = _error;
    slackWebHook.sendLog({
        requestUrl: `[${config?.method?.toUpperCase()}] ${config?.url}`,
        message: '[onApiResponseError]',
        status,
        code,
    });
    // https://barogo.slack.com/archives/C04UP4VFCKA/p1735793975489739?thread_ts=1735793607.848149&cid=C04UP4VFCKA
    const error = BusinessError.convertErrorObject(_error);
    // 401
    // 인증 에러 -> Logout / 로그인 페이지인 경우 x
    const isNotLoginPage = vuexStore.getters['app/getterCurrentPageName'] !== routeName.LOGIN;
    if (isNotLoginPage && status === 401) {
        vuexStore.dispatch('user/logout');
        return;
    }
    // 408
    // timeout이 발생한 경우와 서버에서 408 에러를 반환할 때를 동시에 처리.
    if (status === 408 || code === errorCodes.ECONNABORTED.code) {
        vuexStore.dispatch(snackbarActionType.showError, i18n.t('common.timeouted'));
    }
    throw error;
};
const applyInterceptorsTo = (baseApi) => {
    baseApi.interceptors.request.use(onApiRequest, onApiRequestError);
    baseApi.interceptors.response.use(onApiResponse, onApiResponseError);
    return baseApi;
};
export default function setClientInstanceInterceptors() {
    applyInterceptorsTo(clientInstance);
    applyInterceptorsTo(authInstance);
}
